<app-header></app-header>

<!--====== PAGE TITLE PART START ======-->
<!-- <div class="banner-active">
    <div class="single-banner bg_cover" *ngFor="let slide of slideData;let index=i" 
         [ngStyle]="{'background-image': 'url('+slide.img+')', 'background-repeat': 'no-repeat'}">
        <div class="banner-overlay">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="banner-content text-center">
                            <h1 data-animation="fadeInLeft" data-delay="0.9s" class="title c-title" [innerHTML]="slide.title"></h1>
                            <span data-animation="fadeInLeft" data-delay="0.5s" class="c-sub-title">{{slide?.subTitle}}</span>
                            <div data-animation="fadeInLeft" data-delay="1.3s">
                                <span class="assurance">{{slide.type}}</span>
                                <div class="barre-bottom"></div>
                                <img class="assu-img" [src]="slide.imgIcon" alt="">
                            </div>
                            <span data-animation="fadeInUp" data-delay="1.6s" class="main-btn-title" *ngIf="title!=''">{{title}}</span>
                            <a class="main-btn" data-animation="fadeInUp" data-delay="1.6s" (click)="currentStep = 0">Obtenir un devis</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->


<div class="banner-active">
    <div class="single-banner bg_cover" *ngFor="let slide of slideData;let index=i" 
         [ngStyle]="{'background-image': 'url('+slide.img+')', 'background-repeat': 'no-repeat'}">
        <div class="banner-overlay">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="banner-content text-center">
                            <h1 data-animation="fadeInLeft" data-delay="0.9s" class="title c-title" [innerHTML]="slide.title"></h1>
                            <span data-animation="fadeInLeft" data-delay="0.5s" class="c-sub-title">{{slide?.subTitle}}</span>
                            <div data-animation="fadeInLeft" data-delay="1.3s">
                                <span class="assurance">{{slide.type}}</span>
                                <div class="barre-bottom"></div>
                                <img class="assu-img" [src]="slide.imgIcon" alt="">
                            </div>
                            <span data-animation="fadeInUp" data-delay="1.6s" class="main-btn-title" *ngIf="title!=''">{{title}}</span>
                            <a class="main-btn" data-animation="fadeInUp" data-delay="1.6s" (click)="getDevisAutre()">Obtenir un devis</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="case-studies-area">
  <div class="container">
    
    <!-- Barre de progression -->
    <div class="row" *ngIf="currentStep > 0 && currentStep < 3">
      <div class="devis">
        <div class="title">Mon devis</div>
        <img src="assets/images/stopwatch.svg" alt="">
      </div>
      <div class="temps">
        <span class="barre-temps"></span>
        <span class="message-temps">En quelques minutes</span>
      </div>
    </div>

    <!-- <div class="progress" *ngIf="currentStep > 0 && currentStep < 3">
      <div class="progress-bar progress-bar-striped progress-bar-animated" 
           [style.width.%]="getProgressPercentage()"></div>
      <span class="text-changement">{{getProgressText()}}</span>
    </div> -->

    <div class="latest-services-area">
      <div class="container">
        <div class="formulaire" *ngIf="currentStep >= 0">
          <form [formGroup]="simulationMrhForm" class="form-wizard-container">
            
            <!-- Page d'accueil -->
            <div class="welcome-step" *ngIf="currentStep === 0">
              <div class="welcome-content">
                <h1>Bonjour ! Je suis Marilyne</h1>
                <h2>Je suis là pour vous aider</h2>
                <p class="welcome-description">
                  Obtenez votre devis d'assurance multirisque habitat en quelques minutes seulement.
                  Je vais vous guider étape par étape pour protéger votre logement et vos biens personnels.
                </p>
                <button class="cta-button" (click)="nextStep()">
                  C'est parti !!
                </button>
              </div>
            </div>

            <!-- Étape 1: Informations générales -->
            <div class="step-container" *ngIf="currentStep === 1">
              <div class="step-header">
                <h2>Informations générales</h2>
                <p class="step-subtitle">Renseignez vos informations personnelles et les détails de votre logement</p>
                <p class="step-note">* montant en CFA XOF</p>
                <div class="step-progress">Étape 1 sur 2</div>
              </div>

              <!-- Informations personnelles -->
              <div class="form-section">
                <!-- <h3 class="section-title">Vos informations personnelles</h3> -->
                
                <div class="form-grid formulaire">
                  <div class="col-lg-6 col-sm-6 pr-0">
                    <div class="input-box mt-30">
                      <input type="text" formControlName="nom" placeholder="Nom du proposant" noAutocomplete>
                      <img class="img-form" popover="Nom du proposant" placement="top" triggers="mouseenter:mouseleave"
                        src="assets/images/icon-personne-morale.svg" alt="">
                      <i class="barre"></i>
                    </div>
                  </div>
                  <div class="col-lg-6 col-sm-6 pr-0">
                    <div class="input-box mt-30">
                      <input type="text" formControlName="adresse" placeholder="Adresse du proposant" noAutocomplete>
                      <img class="img-form" popover="Adresse du proposant" placement="top" triggers="mouseenter:mouseleave"
                        src="assets/images/icon-adresse.svg" alt="">
                      <i class="barre"></i>
                    </div>
                  </div>
                </div>

                <div class="form-grid formulaire">
                  <div class="col-lg-6 col-sm-6 pr-0">
                    <div class="input-box mt-30">
                      <input type="email" formControlName="email" placeholder="Courriel *" noAutocomplete>
                      <img class="img-email" popover="Email" placement="top" triggers="mouseenter:mouseleave"
                        src="assets/images/icon-email.svg" alt="">
                      <i class="barre"></i>
                    </div>
                     <div *ngIf="simulationMrhForm.get('email').errors">
                      <div
                        *ngIf="simulationMrhForm.get('email').errors.required && (simulationMrhForm.get('email').dirty || simulationMrhForm.get('email').touched)">
                        <div class="text-red">
                          Ce champs est obligatoire
                        </div>
                      </div>
                      <div *ngIf="simulationMrhForm.get('email').errors.pattern">
                        <div class="text-red">
                          Email est invalide
                        </div>
                      </div>
                  </div>
                  </div>
                  <div class="col-lg-6 col-sm-6 pr-0">
                    <div class="input-box sinistre mt-30">
                      <input type="tel" 
                             formControlName="telephone"
                             ng2TelInput 
                             [ng2TelInputOptions]="{initialCountry: currentFiliale?.code}"
                             placeholder="Numéro de téléphone *"
                             (focus)="isFocus=true" 
                             (blur)="isFocus=false; hasError($event, 'telephone', 'simulationMrhForm');autoSave()"
                             (ng2TelOutput)="getNumber($event, 'telephone', 'simulationMrhForm')"
                             (intlTelInputObject)="telInputObject($event)" 
                             (countryChange)="onCountryChange($event)" noAutocomplete>
                    </div>
                    <div *ngIf="simulationMrhForm.get('telephone').errors">
                      <div
                        *ngIf="simulationMrhForm.get('telephone').errors.required && (simulationMrhForm.get('telephone').dirty || simulationMrhForm.get('telephone').touched)">
                        <div class="text-red">
                          Ce champs est obligatoire
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="formulaire form-grid">
                  <div class="col-lg-6 col-sm-6 pr-0">
                    <div class="input-box">
                      <input type="text" formControlName="profession" placeholder="Profession" noAutocomplete>
                      <img class="img-form" popover="Profession" placement="top" triggers="mouseenter:mouseleave"
                        src="assets/images/icon-fonction.svg" alt="">
                      <i class="barre"></i>
                    </div>
                  </div>

                  <div class="col-lg-6 col-sm-6 pr-0">
                    <div class="input-box">
                      <ng-select (change)="onQualiteProposantChange()" formControlName="qualiteProposant" 
                                clearAllText="Effacer tout" 
                                notFoundText="Aucun élément trouvé"
                                [items]="listQualiteProposant" 
                                bindLabel="name" 
                                bindValue="value"
                                placeholder="Qualité du proposant">
                      </ng-select>
                      <span class="input-icon">
                        <img src="assets/images/nom.svg" alt="">
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Informations sur le logement -->
              <div class="form-section">
                <!-- <h3 class="section-title">Informations sur votre logement</h3> -->
                
                <div class="form-grid formulaire">
                  <div class="col-lg-6 col-sm-6 pr-0">
                    <div class="input-box mt-30">
                      <input type="text" formControlName="adresseRisque" placeholder="Adresse du risque à garantir">
                      <img class="img-form" popover="Adresse du risque" placement="top" triggers="mouseenter:mouseleave"
                        src="assets/images/icon-adresse.svg" alt="">
                      <i class="barre"></i>
                    </div>
                  </div>
                  <div class="col-lg-6 col-sm-6 pr-0">
                    <div class="input-box mt-30">
                      <input type="number" formControlName="nombrePieces" placeholder="Nombre de pièces">
                      <img class="img-form" popover="Nombre de pièces" placement="top" triggers="mouseenter:mouseleave"
                        src="assets/images/icon-valeur-locative.svg" alt="">
                      <i class="barre"></i>
                    </div>
                  </div>
                </div>

                <div class="form-grid formulaire">
                  <div class="col-lg-6 col-sm-6 pr-0">
                    <div class="input-box">
                      <input type="text" 
                             formControlName="valeurContenu" 
                             placeholder="Valeur du contenu"
                             (input)="onMontantInput($event, 'valeurContenu')">
                      <img class="img-form" popover="Valeur du contenu" placement="top" triggers="mouseenter:mouseleave"
                        src="assets/images/icon-valeur-locative.svg" alt="">
                      <i class="barre"></i>
                    </div>
                  </div>
                  <div class="col-lg-6 col-sm-6 pr-0">
                    <div class="input-box">
                      <input type="text" 
                             formControlName="valeurBatiment" 
                             placeholder="Valeur du bâtiment"
                             (input)="onMontantInput($event, 'valeurBatiment')">
                      <img class="img-form" popover="Valeur du bâtiment" placement="top" triggers="mouseenter:mouseleave"
                        src="assets/images/icon-valeur-locative.svg" alt="">
                      <i class="barre"></i>
                    </div>
                  </div>
                </div>

                <div class="form-grid formulaire">
                  <div class="col-lg-6 col-sm-6 pr-0">
                    <div class="input-box" *ngIf="simulationMrhForm.get('qualiteProposant')?.value === 'Locataire'">
                      <input type="text" 
                             formControlName="loyer" 
                             placeholder="Loyer mensuel"
                             (input)="onMontantInput($event, 'loyer')">
                      <img class="img-form" popover="Loyer mensuel" placement="top" triggers="mouseenter:mouseleave"
                            src="assets/images/icon-valeur-locative.svg" alt="">
                      <i class="barre"></i>
                    </div>
                  </div>
                </div>
              </div>

              <div class="step-navigation">
                <button class="btn-back" (click)="currentStep = 0">Retour</button>
                <button class="btn-continue" 
                        [disabled]="!isCurrentStepValid()"
                        (click)="nextStep()">Continuer</button>
              </div>
            </div>

            <!-- Étape 2: Choix des garanties -->
            <div class="step-container" *ngIf="currentStep === 2">
              <div class="step-header">
                <h2>Choix des garanties</h2>
                <p class="step-subtitle">Sélectionnez les garanties adaptées à vos besoins</p>
                <div class="step-progress">Étape 2 sur 2</div>
              </div>

              <!-- Garanties -->
              <div class="formulaire">
                <div class="input-checkbox">
                  <div class="row">
                    <div class="isLabel">Garanties souhaitées</div>
                    <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let garantie of listGaranties">
                      <input type="checkbox" 
                             [id]="'garantie_' + garantie.value" 
                             [checked]="isGarantieSelected(garantie.value)"
                             (change)="onGarantieChange(garantie.value, $event)" />
                      <label [for]="'garantie_' + garantie.value">{{garantie.name}}</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="step-navigation">
                <button class="btn-back" (click)="previousStep()">Retour</button>
                <button class="btn-continue" 
                        [disabled]="!isCurrentStepValid()"
                        (click)="nextStep()">Voir le récapitulatif</button>
              </div>
            </div>

            <!-- Récapitulatif -->
            <div class="step-container_2" *ngIf="currentStep === 3">
              <div class="step-header">
                <h2>Récapitulatif de votre demande d'assurance multirisque habitat</h2>
                <p class="step-subtitle">Vérifiez vos informations avant de finaliser</p>
              </div>

              <div class="recap-form-container">
                <div class="mesImage">
                  <div class="imgLogo">
                    <img src="assets/images/logo.png" alt="Logo Inclusive Guarantee">
                  </div>
                </div>
                
                <div class="info-devis">
                  <div class="proposition">
                    <div class="pro-title">Demande d'assurance multirisque habitat</div>
                    <div class="sub-title">{{numeroSous}}</div>
                  </div>
                  
                  <div class="row">
                    <!-- Informations personnelles -->
                    <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-6">
                      <div class="title-div">
                        <span>Informations personnelles</span>
                      </div>
                      <div class="contenu-div">
                        <div class="row">
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Numéro</div>
                            <div class="col-7 value">{{numeroSous}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Nom</div>
                            <div class="col-7 value">{{simulationMrhForm?.get('nom')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="simulationMrhForm?.get('adresse')?.value">
                            <div class="col-5 name">Adresse</div>
                            <div class="col-7 value">{{simulationMrhForm?.get('adresse')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="simulationMrhForm?.get('email')?.value">
                            <div class="col-5 name">Email</div>
                            <div class="col-7 value">{{simulationMrhForm?.get('email')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Téléphone</div>
                            <div class="col-7 value">{{simulationMrhForm?.get('telephone')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Profession</div>
                            <div class="col-7 value">{{simulationMrhForm?.get('profession')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Qualité proposant</div>
                            <div class="col-7 value">{{simulationMrhForm?.get('qualiteProposant')?.value}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Informations logement et garanties -->
                    <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-6">
                      <div class="title-div">
                        <span>Informations logement et garanties</span>
                      </div>
                      <div class="contenu-div">
                        <div class="row">
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Référence</div>
                            <div class="col-7 value">{{refPro}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Adresse du risque</div>
                            <div class="col-7 value">{{simulationMrhForm?.get('adresseRisque')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Nombre de pièces</div>
                            <div class="col-7 value">{{simulationMrhForm?.get('nombrePieces')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Valeur contenu</div>
                            <div class="col-7 value">{{simulationMrhForm?.get('valeurContenu')?.value}} CFA</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Valeur bâtiment</div>
                            <div class="col-7 value">{{simulationMrhForm?.get('valeurBatiment')?.value}} CFA</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="simulationMrhForm?.get('loyer')?.value">
                            <div class="col-5 name">Loyer mensuel</div>
                            <div class="col-7 value">{{simulationMrhForm?.get('loyer')?.value}} CFA</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Garanties</div>
                            <div class="col-7 value">
                              <span *ngFor="let garantie of simulationMrhForm?.get('garanties')?.value; let last = last">
                                {{garantie}}<span *ngIf="!last">, </span>
                              </span>
                            </div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Date de demande</div>
                            <div class="col-7 value">{{newDate | date:'dd/MM/yyyy'}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="description-ass">
                    Cette demande d'assurance multirisque habitat sera traitée par nos équipes dans les plus brefs délais. 
                    Vous recevrez une confirmation par email avec les détails de votre couverture.
                  </div>
                  
                  <div class="disposition row col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div class="title-dispo-footerL col-md-6 col-lg-6 col-sm-12 col-xs-12">
                      Demande d'assurance multirisque habitat
                    </div>
                    <div class="title-dispo-footerR col-md-6 col-lg-6 col-sm-12 col-xs-12">
                      Date émission : {{newDate | date:'dd/MM/yyyy'}} - E-MAIL : contact&#64;inclusiveguarantee.fr
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="step-navigation">
                <button class="btn-back" (click)="previousStep()">
                  <!-- <i class="fa fa-arrow-left"></i> -->
                  Retour
                </button>
                <button type="button" class="btn-continue final-btn" [disabled]="sendingRequest" (click)="saveData()">
                  <i class="fa fa-spinner fa-pulse" *ngIf="sendingRequest"></i>
                  <span *ngIf="!sendingRequest">Finaliser la souscription</span>
                  <span *ngIf="sendingRequest">Traitement en cours...</span>
                </button>
              </div>
            </div>

            <!-- Étape succès -->
            <div class="step-container" *ngIf="currentStep === 4">
              <div class="success-auto">
                <div class="icon-succes">
                   <img width="10%" src="/assets/images/verifier.png" alt="" srcset="">
                </div>
                <!-- <div class="message-success">
                  Votre demande d'assurance multirisque habitat a été enregistrée avec succès !
                  <span>Numéro de référence : {{numeroSous}}</span>
                  <span>Nos équipes vous contacteront dans les plus brefs délais.</span>
                </div> -->
                <div class="message-success">
                  Votre demande a été soumise avec succès. Vous recevrez un devis sous 48h. Merci pour la confiance.
                  <span>L'équipe d'Inclusive Guarantee</span>
                </div>
                <button class="btn-success" (click)="resetForm()">
                  <span>Nouvelle demande</span>
                </button>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>

